import callApiAxiosClient from '../../axios/axios_client';

async function deleteCategories(items: number[]): Promise<number> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient<number>({
    method: 'delete',
    url: 'categories/delete-categories',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    data: items,
  });
}

export default deleteCategories;
